export default __webpack_public_path__ + "static/media/trash.fcca2778.svg";